import { merge, Observable } from 'rxjs'
import trackActions from '../../../actions/tracks'
import roomActions from '../../../actions/room'

export default function (localParticipant, state) {

  return new Observable(observer => {
    merge(
      localParticipant.on('trackPublished', (publication) => {

        if (publication.isTrackEnabled) {

          if (publication.kind === 'audio') observer.next(trackActions.setEnabledAudioTrackEntry(publication.trackSid))
          if (publication.kind === 'video') observer.next(trackActions.setEnabledVideoTrackEntry(publication.trackSid))

        }

        return observer.next(roomActions.localTrackPublished(localParticipant, publication))

      }),
      localParticipant.on('trackPublicationFailed', (e, localTrack) => {

        if (localTrack.kind === 'video') observer.next(trackActions.createLocalVideoTrack())

      }),
      localParticipant.on('trackStopped', (stoppedTrack) => {

        for (const [label, { track }] of localParticipant.videoTracks) {

          if (stoppedTrack === track) {

            observer.next(trackActions.removeEnabledVideoTrackEntry(label))
            localParticipant.unpublishTrack(stoppedTrack)
            observer.next(trackActions.unattachedTrack(localParticipant.sid, label))

          }

        }

      }),
      localParticipant.on('trackDisabled', (localTrack) => {

        if (localTrack.kind === 'audio') {

          observer.next(roomActions.participantMuted(localParticipant.identity))

          for (const audioPublication of localParticipant.audioTracks.values()) {

            if (audioPublication.track.id === localTrack.id) {

              observer.next(trackActions.removeEnabledAudioTrackEntry(audioPublication.trackSid))

            }

          }

        }
        if (localTrack.kind === 'video') {

          observer.next(roomActions.participantCamHidden(localParticipant.identity))

          for (const videoPublication of localParticipant.videoTracks.values()) {

            if (videoPublication.track.id === localTrack.id) observer.next(trackActions.removeEnabledVideoTrackEntry(videoPublication.trackSid))

          }

        }

      }),
      localParticipant.on('trackEnabled', (localTrack) => {

        if (localTrack.kind === 'audio') {

          observer.next(roomActions.participantUnmuted(localParticipant.identity))

          for (const audioPublication of localParticipant.audioTracks.values()) {

            if (audioPublication.track.id === localTrack.id) {

              observer.next(trackActions.setEnabledAudioTrackEntry(audioPublication.trackSid))

            }

          }

        }

        if (localTrack.kind === 'video') {

          for (const videoPublication of localParticipant.videoTracks.values()) {

            if (videoPublication.track.id === localTrack.id) {

              observer.next(trackActions.setEnabledVideoTrackEntry(videoPublication.trackSid))

            }

          }

          observer.next(roomActions.participantCamVisible(localParticipant.identity))

        }

      }),
      localParticipant.on('disconnected', (participant) => {

        if (state.value.config.bridgeName !== "") {
          return observer.next(roomActions.reconnectRoom(participant))
        } else {
          return observer.next(roomActions.twilioRoomDisconnected())
        }
      }),
      localParticipant.on(`trackPublicationFailed`, (e, localTrack) => console.log('Received trackPublicatioNError', e, localTrack)),
      localParticipant.on('networkQualityLevelChanged', level => observer.next(roomActions.networkQualityChange(level)))
    )
  })

}
